import React from 'react';
import ThemeProvider from 'components/ThemeProvider';
import ThemeSection from 'components/ThemeSection';
import getBaseTheme from 'styles/getBaseTheme';
import { jsx as _jsx } from "react/jsx-runtime";
var baseTheme = getBaseTheme();
function PageThemeProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: baseTheme,
    children: /*#__PURE__*/_jsx(ThemeSection, {
      name: "page",
      children: children
    })
  });
}
export default PageThemeProvider;